export const articleContentReplacator = (articleContent, replace = []) => {
    let content = articleContent;
    console.log(articleContent)
    if (content !== undefined)
        for (const repl of replace) {
            content = content.replace(new RegExp(repl.old, 'g'), repl.new);
        }

    return content;
}

export default articleContentReplacator;